import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { Flex, font, themedColor, Box, useViewportSize, useElementScrollState } from '@lemonade-hq/cdk';
import { Button, Switch, InputText } from '@lemonade-hq/nuis';
import { isValidEmail } from '@lemonade-hq/ts-helpers';
import { rgba } from 'polished';
import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { View } from './types.esm.js';
import { useComplianceProvider } from '../../providers/ComplianceProvider.esm.js';
import { useCommonI18nContext } from '../../providers/I18nProvider.esm.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  flex-direction: column;\n  padding: 32px;\n  justify-content: space-between;\n  height: 100%;\n  isolation: isolate;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  align-items: center;\n  justify-content: ",
        ";\n  gap: 12px;\n  position: relative;\n  z-index: 1;\n  text-align: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  ",
        ";\n  color: ",
        ";\n  text-transform: uppercase;\n  text-align: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  height: 14px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 20px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  flex-direction: column;\n  flex: 1 1 70%;\n  ",
        ";\n  color: ",
        ";\n\n  > h5 {\n    color: ",
        ";\n    font-size: 1.4rem;\n    margin: 0;\n    padding: 0;\n    margin-bottom: 4px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  display: block;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  height: 20px;\n  transform: translateY(-100%);\n  pointer-events: none;\n  background: linear-gradient(\n    to bottom,\n    ",
        " 0%,\n    ",
        " 50%,\n    ",
        "\n  );\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 30px;\n  transform: translateY(100%);\n  pointer-events: none;\n  background: linear-gradient(\n    to top,\n    ",
        " 0%,\n    ",
        " 50%,\n    ",
        "\n  );\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  z-index: 1;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  overflow-y: auto;\n  width: calc(100% + 26px);\n  padding: 20px 24px 20px 0;\n  /* Foreground, Background */\n  scrollbar-color: ",
        " ",
        ";\n  scrollbar-width: thin;\n  &::-webkit-scrollbar {\n    width: ",
        "px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: ",
        ";\n    height: 10px;\n  }\n  &::-webkit-scrollbar-track {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  &:not([disabled]) + label {\n    background-color: ",
        ";\n  }\n  &:hover:not([disabled]) + label {\n    border-color: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: 100%;\n  height: 2px;\n  background: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  background: transparent;\n  margin-top: 16px;\n  position: relative;\n\n  svg {\n    fill: ",
        ";\n  }\n\n  input {\n    background: transparent !important;\n    color: ",
        "!important;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  margin-top: 8px;\n  gap: 5px;\n  color: ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
var CUSTOMIZE_WIDTH = 400;
var CUSTOMIZE_MAX_HEIGHT_CCPA = 427;
var SCROLL_GUTTER = 5;
var OVERLAY_OPACITY_START = 0.1;
var CookieConsentCustomizeWrapper = styled(Flex)(_templateObject());
var HeadingRow = styled(Flex)(_templateObject1(), function(param) {
    var isPersonalInfoView = param.isPersonalInfoView;
    return isPersonalInfoView ? "center" : "space-between";
});
var Title = styled.h3(_templateObject2(), font("main", {
    fontSize: "1.6rem",
    lineHeight: "1.9rem",
    fontWeight: 700
}), themedColor("white"));
var NakedButton = styled.button.attrs({
    type: "button"
})(_templateObject3());
var ListItem = styled(Flex)(_templateObject4());
var Copy = styled(Flex)(_templateObject5(), font("main", {
    fontSize: "1.4rem",
    lineHeight: "1.8rem"
}), themedColor("metal"), themedColor("white"));
var Overlay = styled(Box)(_templateObject6(), function(param) {
    var theme = param.theme;
    return rgba(theme.colors.night, OVERLAY_OPACITY_START);
}, function(param) {
    var theme = param.theme;
    return rgba(theme.colors.night, 0.5);
}, themedColor("night"));
var TopOverlay = styled(Box)(_templateObject7(), function(param) {
    var theme = param.theme;
    return rgba(theme.colors.night, OVERLAY_OPACITY_START);
}, function(param) {
    var theme = param.theme;
    return rgba(theme.colors.night, 0.5);
}, themedColor("night"));
var RelativeWrapper = styled(Box)(_templateObject8());
var CookiesCategoriesWrapper = styled(Box)(_templateObject9(), themedColor("nightRider"), themedColor("night"), SCROLL_GUTTER, themedColor("nightRider"), themedColor("night"));
var ConfirmButton = styled(Button).attrs({
    size: "tiny",
    flavor: "primary"
})(_templateObject10());
var StyledSwitch = styled(Switch)(_templateObject11(), themedColor("boulder"), themedColor("boulder"));
var Divider = styled.div(_templateObject12(), themedColor("boulder"));
var StyledEmailInput = styled(InputText)(_templateObject13(), themedColor("white"), themedColor("white"));
var StyledErrorMessage = styled(Flex)(_templateObject14(), themedColor("white"));
var BackIcon = function() {
    return /*#__PURE__*/ jsx("svg", {
        fill: "none",
        height: 14,
        viewBox: "0 0 8 14",
        width: 8,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ jsx("path", {
            d: "M6.881 1.61 1.12 7.192 6.88 12.39",
            stroke: "#B7B7B7",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
        })
    });
};
var CustomNoticeIcon = function() {
    return /*#__PURE__*/ jsxs("svg", {
        fill: "none",
        height: 18,
        width: 18,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ jsx("circle", {
                cx: 9,
                cy: 9,
                fill: "#FF0083",
                r: 7
            }),
            /*#__PURE__*/ jsx("path", {
                clipRule: "evenodd",
                d: "M10.141 3.828v3.411c0 .473-.028.942-.084 1.407-.057.466-.132.94-.224 1.423h-1.62a21.118 21.118 0 0 1-.223-1.423 11.653 11.653 0 0 1-.085-1.407V3.828h2.236ZM7.643 12.853a1.28 1.28 0 0 1 .39-.933A1.36 1.36 0 0 1 9 11.535c.19 0 .368.034.532.104.165.07.309.163.432.281a1.276 1.276 0 0 1 .393.933 1.306 1.306 0 0 1-.393.941c-.123.119-.267.211-.432.278a1.4 1.4 0 0 1-.532.1 1.42 1.42 0 0 1-.54-.1 1.294 1.294 0 0 1-.713-.698 1.308 1.308 0 0 1-.104-.52Z",
                fill: "#fff",
                fillRule: "evenodd"
            })
        ]
    });
};
var Customize = function(param) {
    var onAccept = param.onAccept, onNavigateBack = param.onNavigateBack, currentView = param.currentView, isClosed = param.isClosed, cookieTypesEnabledState = param.cookieTypesEnabledState, setCookieTypesEnabledState = param.setCookieTypesEnabledState, isPersonalInfoView = param.isPersonalInfoView;
    var isConsentBannerShown = useComplianceProvider().isConsentBannerShown;
    var _useCommonI18nContext = useCommonI18nContext(), t = _useCommonI18nContext.t, s = _useCommonI18nContext.s;
    var width = useViewportSize().width;
    var _useElementScrollState = useElementScrollState(), ref = _useElementScrollState.ref, isScrolling = _useElementScrollState.isScrolling, hasReachedScrollEnd = _useElementScrollState.hasReachedScrollEnd;
    var _useState = _sliced_to_array(useState(""), 2), email = _useState[0], setEmail = _useState[1];
    useEffect(function() {
        if (isConsentBannerShown) return;
        setEmail("");
    }, [
        isConsentBannerShown
    ]);
    var inView = !isClosed && currentView === View.Customize;
    var tabIndex = inView ? undefined : -1;
    var handleUpdateCookieTypeState = function(level) {
        if (cookieTypesEnabledState.includes(level)) {
            setCookieTypesEnabledState(cookieTypesEnabledState.filter(function(item) {
                return item !== level;
            }));
        } else {
            setCookieTypesEnabledState(_to_consumable_array(cookieTypesEnabledState).concat([
                level
            ]));
        }
    };
    var cookiesCategories = [
        {
            title: t("cookie_consent.customize.categories.essential.title"),
            description: t("cookie_consent.customize.categories.essential.description"),
            checked: true,
            isDisabled: true,
            handleCookieChange: function() {},
            id: "essential"
        },
        {
            title: t("cookie_consent.customize.categories.performance.title"),
            description: t("cookie_consent.customize.categories.performance.description"),
            checked: cookieTypesEnabledState.includes("performance"),
            isDisabled: false,
            handleCookieChange: function() {
                return handleUpdateCookieTypeState("performance");
            },
            id: "performance"
        }
    ];
    var analyticsItem = {
        title: t("cookie_consent.customize.categories.tracking.title"),
        description: t("cookie_consent.customize.categories.tracking.description"),
        checked: cookieTypesEnabledState.includes("analytics"),
        isDisabled: false,
        handleCookieChange: function() {
            return handleUpdateCookieTypeState("analytics");
        },
        id: "analytics"
    };
    var finalCookiesCategories = _to_consumable_array(cookiesCategories).concat([
        analyticsItem
    ]);
    return /*#__PURE__*/ jsxs(CookieConsentCustomizeWrapper, {
        "aria-current": inView ? "step" : undefined,
        "aria-hidden": inView ? undefined : true,
        width: [
            width,
            CUSTOMIZE_WIDTH
        ],
        children: [
            /*#__PURE__*/ jsxs(HeadingRow, {
                isPersonalInfoView: isPersonalInfoView,
                children: [
                    !isPersonalInfoView && /*#__PURE__*/ jsx(NakedButton, {
                        "aria-label": "Go back",
                        onClick: onNavigateBack,
                        tabIndex: tabIndex,
                        children: /*#__PURE__*/ jsx(BackIcon, {})
                    }),
                    /*#__PURE__*/ jsx(Title, {
                        children: t("cookie_consent.information.customize_btn_title")
                    }),
                    isScrolling && /*#__PURE__*/ jsx(TopOverlay, {}),
                    !isPersonalInfoView && /*#__PURE__*/ jsx(Box, {
                        width: 19
                    })
                ]
            }),
            /*#__PURE__*/ jsx(CookiesCategoriesWrapper, {
                ref: ref,
                children: isPersonalInfoView ? /*#__PURE__*/ jsxs(Fragment, {
                    children: [
                        /*#__PURE__*/ jsx(ListItem, {
                            children: /*#__PURE__*/ jsxs(Copy, {
                                children: [
                                    /*#__PURE__*/ jsx("h5", {
                                        children: t("cookie_consent.customize.personalInfo.block1.title")
                                    }),
                                    /*#__PURE__*/ jsx("p", {
                                        children: t("cookie_consent.customize.personalInfo.block1.description")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ jsxs(ListItem, {
                            children: [
                                /*#__PURE__*/ jsxs(Copy, {
                                    children: [
                                        /*#__PURE__*/ jsx("h5", {
                                            children: analyticsItem.title
                                        }),
                                        /*#__PURE__*/ jsx("p", {
                                            children: analyticsItem.description
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ jsx(StyledSwitch, {
                                    "aria-checked": analyticsItem.checked,
                                    disabled: analyticsItem.isDisabled,
                                    id: analyticsItem.id,
                                    onChange: analyticsItem.handleCookieChange,
                                    size: "small",
                                    tabIndex: tabIndex,
                                    value: analyticsItem.checked
                                })
                            ]
                        }),
                        /*#__PURE__*/ jsx(ListItem, {
                            children: /*#__PURE__*/ jsxs(Copy, {
                                children: [
                                    /*#__PURE__*/ jsx("h5", {
                                        children: t("cookie_consent.email.section.title")
                                    }),
                                    /*#__PURE__*/ jsx("p", {
                                        children: t("cookie_consent.email.section.description")
                                    }),
                                    /*#__PURE__*/ jsx(StyledEmailInput, {
                                        floatingLabel: true,
                                        icon: "email",
                                        onChange: function(e) {
                                            return setEmail(e.target.value);
                                        },
                                        placeholder: s("cookie_consent.email.input.placeholder"),
                                        value: email
                                    }),
                                    !isValidEmail(email) && email.length > 0 && /*#__PURE__*/ jsxs(StyledErrorMessage, {
                                        children: [
                                            /*#__PURE__*/ jsx(Flex, {
                                                flexShrink: 0,
                                                children: /*#__PURE__*/ jsx(CustomNoticeIcon, {})
                                            }),
                                            /*#__PURE__*/ jsx("span", {
                                                children: t("cookie_consent.email.section.error.message")
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ jsx(ListItem, {
                            children: /*#__PURE__*/ jsx(Divider, {})
                        }),
                        /*#__PURE__*/ jsx(ListItem, {
                            children: /*#__PURE__*/ jsx(Copy, {
                                children: /*#__PURE__*/ jsx("p", {
                                    children: t("cookie_consent.customize.personalInfo.block3.description")
                                })
                            })
                        })
                    ]
                }) : /*#__PURE__*/ jsx(Fragment, {
                    children: finalCookiesCategories.map(function(category) {
                        return /*#__PURE__*/ jsxs(ListItem, {
                            children: [
                                /*#__PURE__*/ jsxs(Copy, {
                                    children: [
                                        /*#__PURE__*/ jsx("h5", {
                                            children: category.title
                                        }),
                                        /*#__PURE__*/ jsx("p", {
                                            children: category.description
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ jsx(StyledSwitch, {
                                    disabled: category.isDisabled,
                                    id: category.id,
                                    onChange: category.handleCookieChange,
                                    size: "small",
                                    tabIndex: tabIndex,
                                    value: category.checked
                                })
                            ]
                        }, category.id);
                    })
                })
            }),
            /*#__PURE__*/ jsxs(RelativeWrapper, {
                children: [
                    !hasReachedScrollEnd && /*#__PURE__*/ jsx(Overlay, {}),
                    /*#__PURE__*/ jsx(ConfirmButton, {
                        onClick: function() {
                            return onAccept({
                                isAcceptAll: false,
                                email: email
                            });
                        },
                        tabIndex: tabIndex,
                        children: t("cookie_consent.customize.confirm_btn_title")
                    })
                ]
            })
        ]
    });
};

export { CUSTOMIZE_MAX_HEIGHT_CCPA, CUSTOMIZE_WIDTH, Customize };
